
import { CCard, CCardBody, CCol, CContainer, CFormInput, CFormLabel, CRow } from '@coreui/bootstrap-react';
import axios from 'axios';
import React, { useState } from 'react';
import { Button, FormGroup } from 'react-bootstrap';
import config from '../config';
import { toast } from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import {useNavigate, useRoutes} from "react-router-dom";

const Login = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);


    const handleLogin = () => {
        if (!username || !password) {
            toast.error('لطفاً نام کاربری و کلمه عبور را وارد کنید')
            return;
        }

        setLoading(true)

        const data = {
            username: username,
            password: password
        };

        axios.post(config.baseUrl + config.endPoints.login, data)
            .then(response => {
                setLoading(false)
                localStorage.setItem('token', response['data']['access']);
                localStorage.setItem('refresh', response['data']['refresh']);
                toast.success('شما با موفقیت وارد حساب کاربری خود شدید، تا لحظات دیگر به داشبورد منتقل خواهید شد.')
                dispatch({
                    type: 'MAKE_LOGIN'
                })
                navigate("/")

            })
            .catch(error => {
                setLoading(false)
                toast.error('خطا در برقرار ارتباط با سرور، لطفا اینترنت خود را بررسی نمایید!')
            });
    };
    return (
        <CContainer>
            <CRow className="justify-content-center mt-5">
                <CCol md={6}>
                    <CCard>
                        <CCardBody>
                            <h1>ورود به حساب کاربری</h1>
                            <FormGroup className='mt-3'>
                                <CFormLabel>نام کاربری</CFormLabel>
                                <CFormInput type="text" placeholder="نام کاربری خود را وارد نمایید ..."
                                            onChange={(e) => (setUsername(e.target.value))}/>
                            </FormGroup>
                            <FormGroup className='mt-2'>
                                <CFormLabel>کلمه عبور</CFormLabel>
                                <CFormInput type="password" placeholder="کلمه عبور خود را وارد نمایید ..."
                                            onChange={(e) => (setPassword(e.target.value))}/>
                            </FormGroup>
                            <Button className='mt-2' color="primary" onClick={() => (handleLogin())}
                                    disabled={loading}>{loading ? "درحال بررسی ..." : "ورود"}</Button>
                        </CCardBody>
                    </CCard>
                </CCol>
            </CRow>
        </CContainer>
    );
};

export default Login;